// extracted by mini-css-extract-plugin
module.exports = {"btn":"_3qd5qjMSmksfrELeeHWC7q","icon":"_2Kfkfv8IcYoWQmIzab6fxv"};